









































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import JsBarcode from 'jsbarcode'
import { formRules } from '@/common/util/validator';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { yun, Inquiry } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import Print from '../../common/util/print'
// import { fmoney } from '@/common/util/money';
// import { Print } from '@/common/util/print'
import {  Loading } from 'element-ui';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        SearchPanel,
        collapse,
        ListFilterPanel,
        DraggerImg,
    },
})
export default class ordermanager extends Vue {
    public JsBarcode = JsBarcode
    public isDisabled: boolean = true;
    public formRules = formRules;
    public publicFunc: any = publicFunc;
    public inquiryType = enums.inquiryType;
    public orderStatusEnum = enums.orderStatusEnum;
    public istState = enums.istState;
    public freightUnitType = enums.freightUnitType;
    public orderTypeList = enums.orderState
    public labelPosition: string = 'right';
    public can0: any = true;
    public can1: any = false;
    public canad: any = true;
    public can2: any = false;
    public can3: any = false;
    public expandType: boolean = false;
    public dayinLog:any = false
    public dayinValue:any = {}
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 0;
    public isActive: boolean = false;
    timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.creationStartTime = value[0];
            this.searchValue.creationEndTime = value[1];
        } else {
            this.searchValue.creationStartTime = null;
            this.searchValue.creationEndTime = null;
        }
    }
    public changeInput(e, index) {
        e.target.value = e.target.value.match(/^[1-9][0-9]*$/) ? e.target.value.match(/^[1-9][0-9]*$/)[0] : '';
        this.fData.oilCardPercent = e.target.value;
    }
    statusArr: any = [];
    public searchValue: any = {
        interceptFlag: '',
        orderStatusList: ['1','6'],
        subOrderNo: '',
        shipOrderNo: '',
        deliveryOrderNo: '',
        carpoolFlag: '',
        closeFlag: '',
        code: '',
        belongCarrierName: '',
        consigneeName: '',
        originAddress: '',
        arrivalAddress: '',
        creationStartTime: '',
        creationEndTime: '',
        orderBy: '',
        isPrint: '',
        orderType:''
    };
    public dayinData:any = []
    public tableData: Array<type.CspInquiryListItem> = [];
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public fData:any = {
        id: '',
        shipOrderNo: '',
        belongCarrierId: '',
        belongCarrierName: '',
        belongRemark: '',
        priceId: '',
        realPrice: '',
        pricingMode: 2,
        oilCardPercent: '',
        paymentWay: ''
    }
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        fData: HTMLFormElement;
        daying: HTMLFormElement,
    };
    //根据权限判断按钮显隐
    public bjfhjh3: boolean = false;
    public zjfhjh3: boolean = false;
    public scfhjh3: boolean = false;
    public fhdw3: boolean = false;
    public dyzyd3: boolean = false;
    public fhjhbbdc3: boolean = false;
    public wcfhjh3: boolean = false;
    public fhjhqh3: boolean = false;
    public fhjhsdxf3: boolean = false;
    public fhjhxz3: boolean = false;




    public ww: any = 1920;
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        console.log('webMenus', webMenus)
        this.bjfhjh3 = webMenus.includes('bjfhjh3');
        this.zjfhjh3 = webMenus.includes('zjfhjh3');
        this.scfhjh3 = webMenus.includes('scfhjh3');
        this.dyzyd3 = webMenus.includes('dyzyd3');
        this.fhjhbbdc3 = webMenus.includes('fhjhbbdc3');
        this.wcfhjh3 = webMenus.includes('wcfhjh3');
        this.fhjhqh3 = webMenus.includes('fhjhqh3');
        this.fhjhsdxf3 = webMenus.includes('fhjhsdxf3');
        this.fhjhxz3 = webMenus.includes('fhjhsdxf3');

        this.fhdw3 = webMenus.includes('fhdw3');
        this.ww = document.documentElement.clientWidth;
    }
    public mounted() {
        if (sessionStorage.getItem('ordermanager_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('ordermanager_searchValue'));
            this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
            if (this.searchValue.statusListStr) {
                this.statusArr = this.searchValue.statusListStr.split(',');
            }

            this.searchPagin = sessionStorage.getItem('ordermanager_page')
                ? JSON.parse(sessionStorage.getItem('ordermanager_page'))
                : this.searchPagin;
            this.getInquiryList();
        } else {
            this.searchPagin = sessionStorage.getItem('ordermanager_page')
                ? JSON.parse(sessionStorage.getItem('ordermanager_page'))
                : this.searchPagin;
            this.getInquiryList();
        }
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'orderStatus':
            {
                this.searchValue.orderBy = '1';
            }
                break;
            case 'subOrderNo':
            {
                this.searchValue.orderBy = '2';
            }
                break;
            case 'consigneeName':
            {
                this.searchValue.orderBy = '3';
            }
                break;
            case 'latestDeliveryTime':
            {
                this.searchValue.orderBy = '4';
            }
                break;
            case 'creationTime':
            {
                this.searchValue.orderBy = '5';
            }
                break;
            // case 'carriageWayStr':
            // {
            //     this.searchValue.orderBy = '7';
            // }
            //     break;
        }
        this.getInquiryList();
    }

    public toOrder(data) {
        this.ssid = '';
        this.ssid = data;
        this.btt = 1;
        this.dialogConfig = {
            title: '终结该发货计划',
            show: true,
        };
    }
    public dialogConfig: any = {
        title: '终结该运单',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    async confirmOk() {
        if (this.btt == 3) {
            yun.deleteOrder(this.ssid).then(() => {
                this.$message.success('发货计划删除成功');
                this.getInquiryList();
            });
        } else if (this.btt == 1) {
            if (this.backs) {
                this.backs = false
                yun.retrieveOrder({
                    id: this.selectionRow[0].id, shipOrderNo: this.selectionRow[0].shipOrderNo
                }).then(() => {
                    this.$message.success('发货计划取回成功');
                    this.$refs.multipleTable.clearSelection();
                    this.getInquiryList();
                });
            } else {
                yun.IupdateOrderStatus({ id: this.ssid, orderStatus: 5 }).then(() => {
                    this.$message.success('发货计划终结成功');
                    this.getInquiryList();
                });
            }

        } else if (this.btt == 2) {
            yun.IupdateOrderStatus({ id: this.ssid.id, orderStatus: 4 }).then(() => {
                this.$message.success('完成该发货计划成功');
                this.getInquiryList();
            });
        }else if (this.btt == 4) {
            this.fData.shipOrderNo = this.detailData.shipOrderNo
            yun.orderIssueSupplier({
                ...this.fData,
            }).then((data) => {
                console.log('data.isIssuedCarrierSuccess',data)
                if (!data.isIssuedCarrierSuccess) {
                    this.$message.success(' 发货计划提交审核');
                } else {
                    this.$message.success(' 发货计划下发成功');
                }
                this.$refs.multipleTable.clearSelection();
                this.carrierVisible = false
                this.getInquiryList();
            });
        }
        this.dialogConfig = {
            show: false,
        };
    }
    handleClose1() {
        this.carrierVisible = false;
    }
    public carCodeEnd() {
        console.log('cc2');
        if (!this.fData.belongCarrierId) {
            this.fData.priceId = '';
            this.fData.realPrice = '';
            this.fData.oilCardPercent = '';
            this.fData.paymentWay = '';
        }
    }
    /**新增询价单 */
    public async addInquiry() {
        this.$refs.fData.validate(async (valid) => {
            if (valid) {
                this.fData.id = this.detailData.id
                this.btt = 4;
                this.dialogConfig = {
                    title: '下发车队',
                    show: true,
                };
            }
        });
    }
    public carCodechange(val) {
        this.fData.belongCarrierId = '';
    }
    async querySearch1(queryString, cb) {
        let res = await yun.GetCarrierByShipper({ carrierName: this.fData.belongCarrierName, customerBaseId :this.detailData.customerBaseId,count: -1 });
        console.log(res);
        let result = [];
        res.forEach((dd) => {
            let xx = {
                value: dd.carrierName,
                carrierId: dd.carrierId,
                relationId: dd.relationId,
            };
            result.push(xx);
        });
        cb(result);
    }
    selectCar1(data) {
        this.fData.belongCarrierId = data.carrierId;
        this.fData.relationId = data.relationId;

        if(this.fData.belongCarrierName =='浙江泰航物流有限公司'){
            this.GetPrice();
        }
    }
    public payTableD:any = []
    async GetPrice() {
        let data = {
            carrierId: this.detailData.customerBaseId,
            arrivalCity: this.detailData.arrivalCity,
            arrivalArea: this.detailData.arrivalCounty,
            deliveryArea: this.detailData.originCounty,
        };
        let res = await yun.GetBasePrice(data);
        console.log('payTableD', res)
        this.payTableD = res.extData
        if (this.payTableD.length == 1) {
            this.selectPay(this.payTableD[0])
        }
        // this.formData.freightUnitPrice = res.extData;
    }
    selectPay(data) {
        this.fData.priceId = data.id
        this.fData.paymentWay = data.paymentWay
        this.fData.oilCardPercent = data.oilCardPercent
        this.fData.realPrice = data.unitPrice
        this.fData.pricingMode = Number(data.pricingMode)
    }
    public isChangeCarrier = false;
    public changeCarrier() {
        this.isChangeCarrier = true;
    }
    public btt: any = 0;
    public ssid: any = '';
    public toEdit(data) {
        console.log('xxxx')
        this.$router.push({
            path: '/addOrder',
            query: {
                id: data.id,
                type: 'edit',
            },
        });
    }

    public getMore() {
        this.expandType = !this.expandType;
    }

    public async exportExcel() {
        let data = await yun.exportOrder(this.searchValue);
        // if (data && data.attachmentUrl) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('导出失败!');
        // }
    }
    public async exportExcel1() {
        let data = await yun.GetOrderTemplate(this.searchValue);
    }
    handleInput1(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : '';
        this.fData.realPrice = e.target.value;
    }
    public getInquiryList() {
        this.loading = true;
        this.searchValue.statusListStr = this.statusArr.join();
        yun.getOrderList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                console.log('this.searchPagin.currentPage', this.searchPagin.currentPage, this.searchPagin.count);
                this.$refs.pagination.setNowPage(this.searchPagin.count);
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public searchFunc() {
        sessionStorage.setItem('ordermanager_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
        this.toggleSelection()
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('ordermanager_page', JSON.stringify(pagin));
        this.getInquiryList();
    }

    public viewInquiry(item) {
        sessionStorage.setItem('ordermanager_page', JSON.stringify(this.searchPagin));
        this.$router.push({
            path: '/AddInquiry',
            query: {
                id: item,
                type: 'order',
            },
        });
    }

    @Watch('tableData')
    handleListDataChange() {
        let tempSelected = JSON.parse(JSON.stringify(this.selectionRow));
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        console.log('this.selectionRow', this.selectionRow);
        this.selectedPreExisting(tempSelected);
        // 以下两行勿删 切换bug
    }
    selectedPreExisting(rows) {
        // let tempSelected = JSON.parse(JSON.stringify(this.selectionRow))
        // let refsElTable = this.$refs.multipleTable as any // 获取表格对象
        // this.$nextTick(() => {tempSelected.forEach(v=>refsElTable.toggleRowSelection(v))});
        // this.$nextTick(() => {tempSelected.forEach(v=>refsElTable.toggleRowSelection(v))});
        if (this.selectionRow.length > 0) {
            let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
            //这里使用this.$nextTick是防止表格未渲染完成就执行，导致无法添加选中效果
            this.$nextTick(() => {
                this.selectionRow.forEach((row) => {
                    //判断row是存在当前tableData
                    this.tableData.forEach((data) => {
                        if (data.id == row.id) {
                            console.log('id', data.id);

                            refsElTable.toggleRowSelection(data, true);
                        }
                    });
                    // let selectedItem = this.tableData.find(item => item.code == row.code)
                    // console.log(selectedItem)
                });
                this.$refs.multipleTable.$forceUpdate();
            });
            console.log('this.selectionRow333', this.ss1, this.ss1.length, this.selectionRow);
        } else {
            this.$refs.multipleTable.clearSelection();
        }
    }
    public selectionRow = [] as any;
    public multipleSelection: any;
    public ss1: any = [];
    handleSelectionChange(rows) {
        this.selectionRow = rows;
        this.canad = true
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        this.selectionRow = rows; //保存已选择行

        if (this.selectionRow.length != 0 &&this.selectionRow[0].orderStatus == '待发布') {
            this.can1 = true
        }else {
            this.can1 = false
        }
        if (this.selectionRow.length != 0 && this.selectionRow[0].isFromTMS) {
            this.can2 = true
            this.selectionRow.map(datax => {
                if (!datax.isFromTMS) {
                    this.can2 = false
                }
            })
        } else {
            this.can2 = false
        }
        if (this.selectionRow.length != 0 && ( this.selectionRow[0].orderStatus == '待接单'
            || this.selectionRow[0].orderStatus == '审核中' ||  this.selectionRow[0].orderStatus == '发运中')) {
            this.can3 = true
        } else {
            this.can3 = false
        }
        if (rows.length > 1) {
            this.can1 = false
            this.canad = false
            this.can3 = false
        }
    }
    /** 单选配置 */
    /* start */
    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    toDetail(row, type) {
        if (row.orderStatus == '待发布' || row.orderStatus == '待接单'|| row.orderStatus == '审核中' || row.orderStatus == '审核退回'  || row.orderStatus == '已终结') {
            this.$router.push({
                path: '/orderDetail',
                query: {
                    id: row.id,
                    name: 'detail',
                },
            });
        } else {
            this.$router.push({
                path: '/orderDetailcc',
                query: {
                    id: row.id,
                    name: 'detail',
                },
            });
        }
    }
    copAdd() {
        if (this.selectionRow.length != 0) {
            this.$router.push({
                path: '/addOrder',
                query: {
                    type: 'copy',
                    id: this.selectionRow[0].id,
                },
            });
        } else {
            this.$router.push({
                path: '/addOrder',
                query: {},
            });
        }
    }

    public handleDelete(data) {
        this.ssid = '';
        this.ssid = data;
        this.btt = 3;
        this.dialogConfig = {
            title: '删除该发货计划',
            show: true,
        };
    }
    public handleFinal(data) {
        this.ssid = '';
        this.ssid = data;
        this.btt = 1;
        this.dialogConfig = {
            title: '终结该发货计划',
            show: true,
        };
    }
    async toend(data) {
        this.ssid = '';
        this.ssid = data;
        this.btt = 2;
        this.dialogConfig = {
            title: '完成该发货计划',
            show: true,
        };
    }

    public handleCommand(command) {
        switch (command.command) {
            case 'toEdit':
                this.toEdit(command.data);
                break;
            case 'delete':
                this.handleDelete(command.data);
                break;
            case 'final':
                this.handleFinal(command.data);
                break;
        }
    }

    beforeHandleCommand(data, command) {
        return {
            data: data,
            command: command,
        };
    }

    public colData =
        JSON.parse(localStorage.getItem('ordermanager')) && JSON.parse(localStorage.getItem('ordermanager')).length == 18
            ? JSON.parse(localStorage.getItem('ordermanager'))
            : [
                { title: '计划状态', isShow: true, disabled: false },
                { title: '计划编号', isShow: true, disabled: false },
                { title: '订单时间', isShow: true, disabled: false },
                { title: '装运单号', isShow: true, disabled: false },
                { title: '客户/基地名称', isShow: true, disabled: false },
                { title: '收货地址', isShow: true, disabled: false },
                { title: '收货方', isShow: true, disabled: false },
                { title: '车队名称', isShow: true, disabled: false },
                { title: '交货单号', isShow: true, disabled: false },
                { title: '打印标识', isShow: true, disabled: false },
                { title: '关单标识', isShow: true, disabled: false },
                { title: '截单标识', isShow: true, disabled: false },
                { title: '子单号', isShow: true, disabled: false },
                { title: '发货地址', isShow: true, disabled: false },
                { title: '客户单位', isShow: true, disabled: false },
                { title: '拼车标识', isShow: true, disabled: false },
                { title: '订单类型', isShow: true, disabled: false },
                { title: '装运单类型', isShow: true, disabled: false },
                { title: '最晚发货时间', isShow: true, disabled: false },
                
            ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('ordermanager', JSON.stringify(this.colData));
    }

    public resetSearchValue() {
        this.searchValue = {
            interceptFlag: '',
            orderStatusList: ['1','6'],
            subOrderNo: '',
            shipOrderNo: '',
            deliveryOrderNo: '',
            carpoolFlag: '',
            closeFlag: '',
            code: '',
            belongCarrierName: '',
            consigneeName: '',
            originAddress: '',
            arrivalAddress: '',
            creationStartTime: '',
            creationEndTime: '',
            orderBy: '',
            isPrint: '',
            orderType:''
        };
        this.statusArr = [];
        this.timeList = [];
        this.searchFunc();
    }
    selectCar2(data) {
        this.searchValue.carrierId = data.id;
    }
    selectList;
    carrierName: any = '';
    async querySearch2(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    errList: any = [];
    batchImportList: any = [];
    errorType: any = '';
    handleClose() {
        this.dialogVisible = false;
    }
    dialogVisible: any = false;
    async updateImage(e: any) {
        this.errList = [];
        let param = new FormData();
        const file = e.file;
        param.append('excel', file);
        let resd = await yun.uploadexcel(param);
        if (!resd.validity) {
            this.errorType = resd.validityStatus;
            if (this.errorType == 1) {
                if (resd.orderList.length == 0) {
                    this.$message.error('Excel表格为空，无法上传！');
                } else {
                    this.$message.error('一次最多上传100条订单，请删减后重新上传！');
                }
            }
            if (this.errorType == 2) {
                this.errList = [];
                this.errList = resd.errRowCellList;
                this.batchImportList = [];
                console.log('res.orderList' + JSON.stringify(resd.orderList));
                resd.orderList.forEach((item) => {
                    this.batchImportList.push(item);
                });
                this.dialogVisible = true;
                console.log('this.errList' + JSON.stringify(this.errList));
            } else if (this.errorType == 3) {
                this.errList = resd.repeatRow;
                this.batchImportList = [];
                resd.orderList.forEach((item) => {
                    this.batchImportList.push(item);
                });
                this.dialogVisible = true;
            }
        } else {
            let res = await yun.orderAddExce1Data({ orderList: resd.orderList });
            this.searchFunc();
            this.$message.success('导入成功!');
        }
    }
    ccdata: any = [];
    async listcc(data, expandedRows) {
        let res = await yun.pageSimpleList({ orderId: data.id, count: -1 });
        this.ccdata[data.id] = res.data;
        this.$refs.multipleTable.toggleRowExpansion();
        this.$refs.multipleTable.toggleRowExpansion();
    }
    toDetail1(row, type) {
        console.log('row', row);
        if (type == 1) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    types: 'ordermanager',
                    id: row.orderList[0].id,
                    name: 'detail',
                    orderCnt: row.orderList.length,
                    //orderId:row.orderList[0].id
                    orderId: row.id,
                    tab: 'second',
                    status: row.carrierOrderStatus,
                    //
                    // id: row.id,
                    // name: 'detail',
                    // orderCnt:row.orderList.length,
                    // orderId:row.orderList[0].id
                },
            });
        } else if (type == 2) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    id: row.id,
                    tab: 'third',
                    orderCnt: row.orderList.length,
                },
            });
        }
    }
    public getcarriageWayColor(val) {
        switch (val) {
            case '待发货':
                return 'dfh';
            case '在途中':
                return 'ztz';
            case '已送达':
                return 'ysd';
            case '已终结':
                return 'yzj';

            default:
                break;
        }
    }
    cellClass({ row, column, rowIndex, columnIndex }) {
        let isr = false;
        this.errList.forEach((data) => {
            // console.log(columnIndex,rowIndex,data,data.cell,data.row-1,this.errList)
            if (columnIndex == data.cell && rowIndex == Number(data.row) - 1) {
                isr = true;
            } else {
            }
        });
        console.log(rowIndex, columnIndex, isr);
        if (isr) {
            return 'border: 2px dashed #f11;position: relative;top:-1px';
        } else {
            return '';
        }
        // for (let i = 0; i < .length; ) {
        //     console.log(columnIndex,rowIndex,i,this.errList[i].cell,Number(this.errList[i].row) - 1,this.errList)
        //
        //
        // }
    }
    getRowKey(row) {
        return row.id;
    }
    handleCancelSelect(data) {
        this.$refs.multipleTable.toggleRowSelection(data);
    }
    toggleSelection() {
        this.$refs.multipleTable.clearSelection();
    }
    flexColumnWidth(str, tableData, flag = 'max') {
        try {
            // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
            // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
            // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
            str = str + '';
            let columnContent = '';
            if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
                return '150px';
            }
            if (!str || !str.length || str.length === 0 || str === undefined) {
                return '150px';
            }
            if (flag === 'equal') {
                // 获取该列中第一个不为空的数据(内容)
                for (let i = 0; i < tableData.length; i++) {
                    if (tableData[i][str].length > 0) {
                        // console.log('该列数据[0]:', tableData[0][str])
                        columnContent = tableData[i][str];
                        break;
                    }
                }
            } else {
                let index = 0;
                for (let i = 0; i < tableData.length; i++) {
                    if (tableData[i][str] === null) {
                        return '150px';
                    }
                    const now_temp = tableData[i][str] + '';
                    const max_temp = tableData[index][str] + '';
                    if (now_temp.length > max_temp.length) {
                        index = i;
                    }
                }
                columnContent = tableData[index][str];
            }
            // console.log('该列数据[i]:', columnContent)
            // 以下分配的单位长度可根据实际需求进行调整
            let flexWidth = 0;
            for (const char of columnContent) {
                if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                    // 如果是英文字符，为字符分配8个单位宽度
                    flexWidth += 9;
                } else if (char >= '\u4e00' && char <= '\u9fa5') {
                    // 如果是中文字符，为字符分配15个单位宽度
                    flexWidth += 14;
                }else if(/[^a-zA-Z0-9]/.test(char)){
                    flexWidth += 14;
                }  else {
                    // 其他种类字符，为字符分配8个单位宽度
                    flexWidth += 10;
                }
            }
            if (str == 'consigneePhone') {
                flexWidth = flexWidth * 2;
            }
            if (flexWidth < 120) {
                // 设置最小宽度
                flexWidth = 150;
            }
            // if (flexWidth > 250) {
            //   // 设置最大宽度
            //   flexWidth = 250
            // }
            return flexWidth + 20 + 'px';
        } catch (e) {
            return '160px';
        }
    }
    async querySearchAsynccc(queryString, cb) {
        var res = await yun.GetCarrierList({ name: queryString, count: 30 });
        var restaurants = [];
        if (res) {
            res.data.forEach((item) => {
                restaurants.push({
                    value: item.name,
                });
            });
            cb(restaurants);
        }
    }
    async querySearchAsyCustomerName(queryString, cb){
            let res = await yun.ShipperGetList({
                name: queryString,
                type: 1,
                count: 30,
            });
            let dds = [];
            if (res) {
                res.forEach((item) => {
                    dds.push({
                        id:item.id,
                        customerBaseCode: item.customerBaseCode,
                        value: item.customerBaseName,
                    });
                });
                cb(dds);
            }
    }
    public detailData:any = {}
    public carrierVisible:any = false
    async copAdd1(data) {
        if (this.selectionRow.length != 0 && this.selectionRow[0].orderStatus == '待发布') {
            let res = await yun.OrdergetDetaill(this.selectionRow[0].id)
            this.fData = {
                id: '',
                shipOrderNo: '',
                belongCarrierId: '',
                belongCarrierName: '',
                belongRemark: '',
                priceId: '',
                realPrice: '',
                pricingMode: 2,
                oilCardPercent: '',
                paymentWay: ''
            }
            console.log('resddddd', res)
            this.detailData = res;
            // this.detailData = this.selectionRow[0]
            this.carrierVisible = true;
            this.$refs.fData.resetFields();
        } else {
            this.$alert('请至少选中一条待发布的发货计划')
        }
    }
    public backs:any = false
    async orderback(data) {
        if (this.selectionRow.length != 0) {
            this.ssid = this.selectionRow[0].id
            this.backs = true
            this.btt = 1
            this.dialogConfig = {
                title: '发货计划取回',
                show: true,
            };
        } else {
            this.$alert('请至少选中一条发货计划')
        }
    }

    getFormatDate() {
        var date = new Date();
        var month: any = date.getMonth() + 1;
        var strDate: any = date.getDate();
        var getHours: any = date.getHours();
        var getMinutes: any = date.getMinutes();
        var getSeconds: any = date.getSeconds();

        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }

        if (getHours >= 0 && getHours <= 9) {
            getHours = "0" + getHours;
        }
        if (getMinutes >= 0 && getMinutes <= 9) {
            getMinutes = "0" + getMinutes;
        }
        if (getSeconds >= 0 && getSeconds <= 9) {
            getSeconds = "0" + getSeconds;
        }

        var currentDate = date.getFullYear() + "." + month + "." + strDate
            + " " + getHours  + ":" + getMinutes + ":" + getSeconds;
        return currentDate;
    }

    public times:any = ''

    public loadingServive:any;
    public async dayin(){
        this.loadingServive = Loading;
        if (this.selectionRow.length != 0 && this.selectionRow[0].isFromTMS) {
            let xx = ''
            this.selectionRow.map((data,index)=> {
                xx = xx +  (index=== 0 ? data.shipOrderNo :','+data.shipOrderNo)
            })
            this.loadingServive = this.loadingServive.service({
                lock: true,
                text: '打印附件生成中.....',
                background: 'rgba(0, 0, 0, 0.7)'
            })
             yun.getOrderPrintList({shipOrderNos: xx}).then(res=>{
                this.loadingServive.close();
                window.open(res,'_blank',`width=${document.body.offsetWidth},height=${document.body.offsetHeight},top=100px,left=0px`);
                yun.Print({shipOrderNos: xx}).then(res => {
                    this.getInquiryList();
                })
             }).catch(err=>{
                this.loadingServive.close()
             })
          
        } else {
            this.$alert('请至少选中一条可以打印的数据')
        }
    }
    public dayinLogClose() {
        this.dayinLog = false
    }
    public $print = Print
    // public Print:any = Print
    public async dayinS(dom: any) {
        let xx = ''
        console.log('xxxx', this.selectionRow)
        this.selectionRow.map((data,index)=> {
            xx = xx +  (index=== 0 ? data.shipOrderNo :','+data.shipOrderNo)
        })
        this.$nextTick(() => {
            this.$print(this.$refs.daying)
        });
        yun.Print({shipOrderNos: xx}).then(res => {
            this.getInquiryList();
        })
       
    }

    public interceptFunc(num){
        const result = /^\d+$/.test(num);
        if(result){
            return parseInt(num)
        }else{
            return num
        }
    }
    /**数组分页 */
     pageFucn(data,pageSize){  
                  let arr = data.map((vv,ii)=>{
                    return{
                        ...vv,
                        indexNum:ii+1
                    }
                })  
            let pageCount = Math.ceil(arr.length/pageSize);
            let result = [];
            for(let i =0;i<pageCount;i++){
                let start = i*pageSize;
                let edd = start + pageSize;
                result.push(arr.slice(start,edd));
            }
            return result;
     }
}
